/* Kaio-Dia - pastilles de variantes sur les cartes produit.
   Un clic sur une pastille change l image de la carte au lieu d ouvrir la fiche.
   Fonctionne dans les cartes du theme FullStack et dans nos propres grilles
   (snippet kd-product-grid).

   Note : les galeries de cartes FullStack sont des carrousels Splide dont la
   translation est neutralisee en CSS ; piloter le carrousel ne deplace donc
   rien visuellement. On remplace directement l image affichee, ce qui marche
   dans tous les cas.

   Survol (ordinateur uniquement) : la deuxieme photo du produit apparait en
   fondu par dessus la premiere, comme sur l ancien theme Avone.
     - cartes du theme : on reprend la 2e image de la galerie de la carte
     - grilles kd-product-grid : attribut data-kd-hover sur .kd-card__media
   L image de survol n est creee qu au premier passage de la souris, pour ne
   rien charger en plus au chargement de la page. Apres un clic sur une
   pastille, le survol est desactive sur cette carte pour ne pas masquer la
   variante choisie.

   Fichier maison, jamais ecrase par une mise a jour du theme. */
(function () {
  'use strict';

  function swapImage(img, src) {
    if (!img || !src) return;
    var picture = img.parentElement;
    if (picture && picture.tagName === 'PICTURE') {
      var sources = picture.querySelectorAll('source');
      for (var i = 0; i < sources.length; i++) sources[i].removeAttribute('srcset');
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.removeAttribute('loading');
    img.src = src;
  }

  function onClick(event) {
    var swatch = event.target.closest ? event.target.closest('[data-kd-swatch]') : null;
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    var card = swatch.closest('product-card, .kd-card');
    if (!card) return;

    card.setAttribute('data-kd-swatched', '');

    var group = swatch.parentElement;
    if (group) {
      var all = group.querySelectorAll('[data-kd-swatch]');
      for (var i = 0; i < all.length; i++) {
        all[i].setAttribute('aria-checked', all[i] === swatch ? 'true' : 'false');
      }
    }

    var src = swatch.dataset.kdSrc;
    if (src) {
      var target =
        card.querySelector('[data-kd-main]') ||
        card.querySelector('.splide__slide.is-active img') ||
        card.querySelector('.splide__slide img') ||
        card.querySelector('img:not(.kd-hover-img)');
      swapImage(target, src);
    }

    if (swatch.dataset.kdUrl) {
      var links = card.querySelectorAll('[data-kd-link]');
      for (var j = 0; j < links.length; j++) links[j].href = swatch.dataset.kdUrl;
      if (card.tagName === 'PRODUCT-CARD') card.dataset.productUrl = swatch.dataset.kdUrl;
    }

    if (swatch.dataset.kdVariant) {
      var button = card.querySelector('[data-ref="add-to-cart-button"]');
      if (button) button.setAttribute('data-variant-id', swatch.dataset.kdVariant);
    }
  }

  document.addEventListener('click', onClick, true);

  /* ---------- Deuxieme image au survol ---------- */

  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!canHover) return;

  var style = document.createElement('style');
  style.textContent =
    '.kd-hover-img{position:absolute;inset:0;width:100%;height:100%;margin:0;opacity:0;background:#fff;' +
    'transition:opacity .35s ease;pointer-events:none;z-index:1;}' +
    'product-card:hover .kd-hover-img.is-ready,.kd-card:hover .kd-hover-img.is-ready{opacity:1;}' +
    '[data-kd-swatched] .kd-hover-img{display:none;}';
  document.head.appendChild(style);

  /* Choisit dans un srcset la variante la plus proche de 600px de large. */
  function pickSrc(img) {
    var set = img.getAttribute('srcset') || img.getAttribute('data-srcset');
    if (set) {
      var best = null, bestDiff = Infinity;
      set.split(',').forEach(function (part) {
        var bits = part.trim().split(/\s+/);
        var w = parseInt(bits[1], 10);
        if (!bits[0] || !w) return;
        var diff = Math.abs(w - 600) + (w < 600 ? 1000 : 0);
        if (diff < bestDiff) { bestDiff = diff; best = bits[0]; }
      });
      if (best) return best;
    }
    return img.getAttribute('src') || img.getAttribute('data-src');
  }

  function prepare(card) {
    if (card.hasAttribute('data-kd-hover-done')) return;
    card.setAttribute('data-kd-hover-done', '');

    var holder, mainImg, src;

    if (card.classList.contains('kd-card')) {
      holder = card.querySelector('.kd-card__media[data-kd-hover]');
      if (!holder) return;
      mainImg = holder.querySelector('[data-kd-main]');
      src = holder.getAttribute('data-kd-hover');
    } else {
      var gallery = card.querySelector('product-card-media-gallery');
      if (!gallery) return;
      var slots = gallery.querySelectorAll('.product-card-media-gallery__media');
      if (slots.length < 2) return;
      holder = slots[0];
      mainImg = holder.querySelector('img');
      var second = slots[1].querySelector('img');
      if (!second) return;
      src = pickSrc(second);
    }
    if (!holder || !mainImg || !src) return;

    if (getComputedStyle(holder).position === 'static') holder.style.position = 'relative';

    var img = document.createElement('img');
    img.className = 'kd-hover-img';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.decoding = 'async';
    var cs = getComputedStyle(mainImg);
    img.style.objectFit = cs.objectFit || 'cover';
    img.style.objectPosition = cs.objectPosition || 'center';
    img.style.borderRadius = cs.borderRadius;
    img.addEventListener('load', function () { img.classList.add('is-ready'); });
    img.src = src;

    if (mainImg.parentElement && mainImg.parentElement.tagName === 'PICTURE' && mainImg.parentElement.parentElement === holder) {
      mainImg.parentElement.insertAdjacentElement('afterend', img);
    } else if (mainImg.parentElement === holder) {
      mainImg.insertAdjacentElement('afterend', img);
    } else {
      holder.appendChild(img);
    }
  }

  document.addEventListener('mouseover', function (event) {
    var card = event.target.closest ? event.target.closest('product-card, .kd-card') : null;
    if (card && !card.hasAttribute('data-kd-swatched')) prepare(card);
  }, { passive: true });
})();
